import React, { useMemo } from 'react';

import { RichText } from 'src/components/RichText/RichText';

import classes from './ProductPromotions.module.scss';
import { parsePromotionsOverrideCmsBlock } from './utils/parse-product-promotions-override-cms-block';

export type ProductPromotionsOverrideProps = {
    cmsBlock?: string;
};

/**
 * Override the Product promotions block with a CMS block.
 */
export function ProductPromotionsOverride(props: ProductPromotionsOverrideProps) {
    const { title, description } = useMemo(() => {
        return parsePromotionsOverrideCmsBlock(props.cmsBlock);
    }, [props.cmsBlock]);

    return (
        <div className={classes.promotions} data-promotions-override>
            <div>
                <h3 className={classes.promotionsTitle}>{title}</h3>
                {description && (
                    <div className={classes.promotionsDesc}>
                        <RichText className={classes.promotionTerms} content={description} />
                    </div>
                )}
            </div>
        </div>
    );
}
